import _ from "lodash";
_
export default {
  data() {
    return {
      companyCreditCards: {
        loading: false,
        pagination: {
          page: 1,
          perPage: 10,
          total: 0,
          totalPages: 0,
        },
        details: {},
        list: [],
        filters: {
          users: {
            list: [],
            selected: [],
          },
          company: {
            list: [],
            selected: [],
          },
          status: {
            list: [{
              label: "Ativo",
              value: "Ativo",
            }, {
              label: "Desativado",
              value: "Desativado",
            }],
            selected: [],
          },
          period: {
            selected: [],
          },
          creditCardId: "",
          companyId: "",
          showInContract: "",
          searchTerm: "",
          order: "desc",
          orderBy: "created",
        }
      }
    };
  },
  methods: {
    changeCompanyCreditCardsPage(current) {
      this.companyCreditCards.pagination.page = current;
      this.getcompanyCreditCards();
    },
    changeCompanyCreditCardsPageSize(current, pageSize) {
      this.companyCreditCards.pagination.page = current;
      this.companyCreditCards.pagination.perPage = pageSize;
      this.getCompanyCreditCards();
    },
    companyCreditCardsTableChange(pagination, filters, sorter) {
      filters;
      pagination;
      this.companyCreditCards.filters.order =
        sorter.order != undefined ? sorter.order : "desc";
      this.companyCreditCards.filters.orderBy =
        sorter.column != undefined ? sorter.column.key : "created";
      this.getCompanyCreditCards();
    },
    getCompanyCreditCards(samePage) {

      let filters = "";

      this.companyCreditCards.loading = true;

      if (this.companyCreditCards.filters.searchTerm) {
        filters += `&s=${this.companyCreditCards.filters.searchTerm}`;
      }

      if (this.companyCreditCards.filters.contractId) {
        filters += `&contract_id=${this.companyCreditCards.filters.contractId}`;
      }

      if (this.companyCreditCards.filters.showInContract) {
        filters += `&show_in_contract=${this.companyCreditCards.filters.showInContract}`;
      }

      if (this.companyCreditCards.filters.creditCardId) {
        filters += `&credit_card_id=${this.companyCreditCards.filters.creditCardId}`;
      }

      if (this.companyCreditCards.filters.operationId) {
        filters += `&credit_card_transaction_id=${this.companyCreditCards.filters.operationId}`;
      }

      if (this.companyCreditCards.filters.status.selected.length > 0) {
        filters += `&status=${this.companyCreditCards.filters.status.selected}`;
      }

      if (this.companyCreditCards.filters.users.selected.length > 0) {
        filters += `&user_id=${this.companyCreditCards.filters.users.selected}`;
      }

      filters += `&order=${this.companyCreditCards.filters.order}&order-by=${this.companyCreditCards.filters.orderBy}`;

      this.$http
        .get(
          `/company-credit-card/list?page=${this.companyCreditCards.pagination.page}&per_page=${this.companyCreditCards.pagination.perPage}${filters}`
        )
        .then(({
          data
        }) => {
          if (!samePage) {
            this.companyCreditCards.pagination.page = 1;
          }
          this.companyCreditCards.pagination.total = data.meta.total;
          this.companyCreditCards.pagination.totalPages = data.meta.total_pages;
          this.companyCreditCards.list = data.data;
          this.companyCreditCards.loading = false;
        })
        .catch(({
          response
        }) => {
          this.companyCreditCards.loading = false;
          this.companyCreditCards.list = response.data.data;
          this.companyCreditCards.pagination.total = response.data.meta.total;
          this.companyCreditCards.pagination.totalPages = response.data.meta.total_pages;
        });
    },

  }

}